import { CustomColumn } from '@/common/utils';

// 주로 rtm 화면에서 사용
export const VIEW_ONLY_ALERT_COLUMNS = [
  {
    caption: 'Rule Name',
    field: 'alertRuleName',
    type: 'string',
    clickable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Alert Stat Name',
    field: 'alertName',
    type: 'string',
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Target',
    field: 'targets',
    type: 'string',
    rendererType: 'chip-cell',
    width: 150,
  },
  {
    caption: 'Alias',
    field: 'targetAlias',
    type: 'string',
    rendererType: 'chip-cell',
    width: 150,
  },
  {
    caption: 'Alert Detail',
    field: 'subName',
    type: 'string',
    width: 150,
  },
  {
    caption: 'Last Triggered',
    field: 'triggerTime',
    type: 'string',
    width: 140,
  },
  {
    caption: 'Rule Type',
    field: 'alertRuleType',
    type: 'string',
    width: 100,
  },
  {
    caption: 'Last Alert',
    field: 'alertLevel',
    type: 'string',
    rendererType: 'label',
    width: 100,
  },
  {
    caption: 'Threshold',
    field: 'threshold',
    type: 'string',
    width: 300,
    sortable: false,
  },
  {
    caption: 'Value',
    field: 'value',
    type: 'string',
    width: 120,
    sortable: false,
  },
  {
    caption: 'Rule ID',
    field: 'alertRuleId',
    type: 'string',
    hide: true,
  },
  {
    caption: 'Rule Name Icon',
    field: 'ruleNameIcon',
    type: 'string',
    hide: true,
  },
  {
    caption: 'Stat Unit',
    field: 'statUnit',
    type: 'string',
    hide: true,
  },
  {
    caption: 'Rule Criteria',
    field: 'ruleCriteria',
    type: 'string',
    hide: true,
  },
  {
    caption: 'resultId',
    field: 'resultId',
    type: 'string',
    hide: true,
    searchable: false,
  },
] as const satisfies CustomColumn[];

// 주로 detail > alert 탭에서 사용
export const SEARCHABLE_ALERT_COLUMNS = [
  {
    caption: 'Rule Name',
    field: 'alertRuleName',
    type: 'string',
    clickable: true,
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Alert Stat Name',
    field: 'alertName',
    type: 'string',
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Target',
    field: 'targets',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Alias',
    field: 'targetAlias',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Alert Detail',
    field: 'subName',
    type: 'string',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Last Triggered',
    field: 'triggerTime',
    type: 'string',
    searchable: true,
    width: 140,
  },
  {
    caption: 'Rule Type',
    field: 'alertRuleType',
    type: 'string',
    searchable: true,
    width: 100,
  },
  {
    caption: 'Last Alert',
    field: 'alertLevel',
    type: 'string',
    rendererType: 'label',
    searchable: true,
    width: 100,
  },
  {
    caption: 'Threshold',
    field: 'threshold',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 300,
  },
  {
    caption: 'Value',
    field: 'value',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 120,
  },
  {
    caption: 'Rule ID',
    field: 'alertRuleId',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Name Icon',
    field: 'ruleNameIcon',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Event Type',
    field: 'eventType',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Criteria',
    field: 'ruleCriteria',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Stat Unit',
    field: 'statUnit',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'resultId',
    field: 'resultId',
    type: 'string',
    hide: true,
    searchable: false,
  },
] as const satisfies CustomColumn[];

//  detail > alert 외부알람 사용
export const SEARCHABLE_ALERT_COLUMNS_HAS_EXTERNAL_LABEL = [
  {
    caption: 'Rule Name',
    field: 'alertRuleName',
    type: 'string',
    clickable: true,
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Alert Stat Name',
    field: 'alertName',
    type: 'string',
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Target',
    field: 'targets',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Alias',
    field: 'targetAlias',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Alert Detail',
    field: 'subName',
    type: 'string',
    width: 200,
    searchable: true,
  },
  {
    caption: 'Last Triggered',
    field: 'triggerTime',
    type: 'string',
    searchable: true,
    width: 140,
  },
  {
    caption: 'Rule Type',
    field: 'alertRuleType',
    type: 'string',
    searchable: true,
    width: 160,
  },

  {
    caption: 'Last Alert',
    field: 'alertLevel',
    type: 'string',
    rendererType: 'label',
    searchable: true,
    width: 100,
  },
  {
    caption: 'Threshold',
    field: 'threshold',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 300,
  },

  {
    caption: 'Value',
    field: 'value',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 120,
  },
  {
    caption: 'Notification Status',
    field: 'notificationStatus',
    type: 'string',
    searchable: false,
    sortable: false,
    width: 146,
  },
  {
    caption: 'Rule ID',
    field: 'alertRuleId',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Name Icon',
    field: 'ruleNameIcon',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Event Type',
    field: 'eventType',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Criteria',
    field: 'ruleCriteria',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Stat Unit',
    field: 'statUnit',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'resultId',
    field: 'resultId',
    type: 'string',
    hide: true,
    searchable: false,
  },
] as const satisfies CustomColumn[];

// home > alert detail
export const SEARCHABLE_ALERT_COLUMNS_HAS_NOTI = [
  {
    caption: 'Rule Name',
    field: 'alertRuleName',
    type: 'string',
    clickable: true,
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Alert Stat Name',
    field: 'alertName',
    type: 'string',
    searchable: true,
    width: 150,
    defaultSearchField: true,
  },
  {
    caption: 'Target',
    field: 'targets',
    type: 'string',
    rendererType: 'chip-cell',
    searchable: false,
    width: 150,
  },
  {
    caption: 'Alert Detail',
    field: 'subName',
    type: 'string',
    searchable: true,
    width: 150,
  },
  {
    caption: 'Last Triggered',
    field: 'triggerTime',
    type: 'string',
    searchable: true,
    width: 140,
  },
  {
    caption: 'Rule Type',
    field: 'alertRuleType',
    type: 'string',
    searchable: true,
    width: 100,
  },
  {
    caption: 'Last Alert',
    field: 'alertLevel',
    type: 'string',
    rendererType: 'label',
    searchable: true,
    width: 100,
  },
  {
    caption: 'Threshold',
    field: 'threshold',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 300,
  },
  {
    caption: 'Value',
    field: 'value',
    type: 'string',
    searchable: true,
    sortable: false,
    width: 120,
  },
  {
    caption: 'Notification Status',
    field: 'notificationStatus',
    type: 'string',
    searchable: false,
    sortable: false,
    width: 146,
  },
  // {
  //   caption: 'Description',
  //   field: 'description',
  //   type: 'string',
  //   searchable: true,
  // },
  {
    caption: 'Rule ID',
    field: 'alertRuleId',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Name Icon',
    field: 'ruleNameIcon',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Event Type',
    field: 'eventType',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Rule Criteria',
    field: 'ruleCriteria',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'Stat Unit',
    field: 'statUnit',
    type: 'string',
    hide: true,
    searchable: false,
  },
  {
    caption: 'resultId',
    field: 'resultId',
    type: 'string',
    hide: true,
    searchable: false,
  },
] as const satisfies CustomColumn[];
